import type { SupportingMethod } from '../types.js';
import { standardDeviation } from '../utils.js';

export const bollingerSqueeze: SupportingMethod = ({ candles, direction }) => {
  const period = 20;
  if (candles.length < 70 || direction === 'neutral') {
    return { id: 'MO-027', name: 'Bollinger squeeze', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candle history or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const widths: number[] = [];
  const bands: Array<{ middle: number; upper: number; lower: number; width: number }> = [];
  for (let i = period - 1; i < candles.length; i += 1) {
    const closes = candles.slice(i + 1 - period, i + 1).map((c) => c.close);
    const middle = closes.reduce((sum, value) => sum + value, 0) / period;
    const sd = standardDeviation(closes);
    const upper = middle + 2 * sd;
    const lower = middle - 2 * sd;
    const width = middle > 0 ? (upper - lower) / middle : 0;
    widths.push(width);
    bands.push({ middle, upper, lower, width });
  }
  const latest = bands.at(-1)!;
  const prior = bands.at(-2)!;
  const baseline = widths.slice(-60, -1);
  const lowWidth = baseline.length > 0 ? Math.min(...baseline) : latest.width;
  const squeezed = latest.width <= Math.max(lowWidth * 1.12, 0.001);
  const expanding = latest.width > prior.width * 1.08;
  const close = candles.at(-1)!.close;
  const breakout = direction === 'long' ? close > latest.upper : close < latest.lower;
  const aligned = (squeezed && expanding && breakout) || (expanding && breakout);
  return {
    id: 'MO-027', name: 'Bollinger squeeze', status: 'experimental', authority: 1, rawSignal: aligned ? 1 : 0, contribution: aligned ? 1 : 0, direction,
    finding: aligned ? `Bollinger width is expanding with a ${direction} band break after compressed volatility.` : 'No qualifying squeeze-release breakout aligned with the Core direction.',
    dataSufficient: true, sampleSize: candles.length,
  };
};
